export const MEDIUM_BREAKPOINT = 768;
export const LARGE_BREAKPOINT = 1024;

export function getIsMediumBreakpoint(
  windowWidth: number,
  isMobileRequest: boolean
) {
  if (!windowWidth) return isMobileRequest;

  return windowWidth && windowWidth >= MEDIUM_BREAKPOINT;
}

export function getIsLargeBreakpoint(
  windowWidth: number,
  isMobileRequest: boolean
) {
  if (!windowWidth) return isMobileRequest;

  return windowWidth && windowWidth >= LARGE_BREAKPOINT;
}
